export const filter = {
    id: "",
    state_id: "",
    region_id: "",
    city_id: "",
    search: "",
    created_at: "",
    updated_at: "",
};
